export const Content = ({ children, className, style={}, ...props }) => {
    return (<div className={'cont-area ' + className} style={style} {...props}>
        {children}
    </div>)
}